import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
type Notification = {
  name: string;
  location: string;
  time: string;
  initials: string;
};
const notifications: Notification[] = [{
  name: 'Jessica Ramirez',
  location: 'Los Angeles, USA',
  time: '5 minutes ago',
  initials: 'JR'
}, {
  name: 'Carlos Mendoza',
  location: 'Miami, USA',
  time: '12 minutes ago',
  initials: 'CM'
}, {
  name: 'Sophie Walker',
  location: 'London, UK',
  time: '18 minutes ago',
  initials: 'SW'
}, {
  name: 'Andrea Lopez',
  location: 'Toronto, Canada',
  time: '27 minutes ago',
  initials: 'AL'
}, {
  name: 'Emily Clarke',
  location: 'Sydney, Australia',
  time: '41 minutes ago',
  initials: 'EC'
}];
export function PurchaseNotifications() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const showTimer = window.setTimeout(() => setVisible(true), 4500);
    return () => window.clearTimeout(showTimer);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    const nextTimer = window.setTimeout(() => {
      setVisible(false);
      window.setTimeout(() => {
        if (!dismissed) {
          setIndex(current => (current + 1) % notifications.length);
          setVisible(true);
        }
      }, 700);
    }, 5000);
    return () => window.clearTimeout(nextTimer);
  }, [visible, dismissed]);
  if (dismissed) return null;
  const notification = notifications[index];
  return <div className="pointer-events-none fixed bottom-4 left-1/2 z-50 flex w-full -translate-x-1/2 justify-center px-4" data-id="element-255" data-mp="yjxtwhkv239s">
      <AnimatePresence mode="wait" data-id="element-256" data-mp="3nca3b39mdo3d">
        {visible && <motion.div key={notification.name} initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 10
      }} transition={{
        duration: 0.25
      }} className="pointer-events-auto relative flex w-full max-w-sm items-center gap-3 rounded-xl border border-gold/40 bg-cream p-3.5 shadow-luxe" data-id="element-257" data-mp="3j9n94vph7r30">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-gold/60 bg-wine text-sm font-semibold text-cream" data-id="element-258" data-mp="31zjbxto2skqe">
              {notification.initials}
            </span>
            <div className="min-w-0 flex-1" data-id="element-259" data-mp="2s3yg6d9logp3">
              <p className="text-xs text-ink-muted" data-id="element-260" data-mp="2x0ykojqsxbe3">
                {notification.location}
              </p>
              <p className="mt-0.5 text-sm leading-5 text-ink" data-id="element-261" data-mp="2j0xd6lg175pn">
                <strong className="font-semibold" data-id="element-262" data-mp="2j3t9648bjkbg">{notification.name}</strong>{' '}
                purchased Salsa & Bachata Instructor Ready
              </p>
              <p className="mt-1 flex items-center gap-1 text-[11px] font-medium text-burgundy" data-id="element-263" data-mp="24fjhgjf860ad">
                <ShoppingBagIcon size={11} aria-hidden="true" data-id="element-264" data-mp="1zgyp1667skwh" /> Verified purchase ·{' '}
                {notification.time}
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close purchase notification" className="self-start rounded text-ink-muted transition-colors duration-150 hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-burgundy" data-id="element-265" data-mp="28glfiwxeo6ar">
              <XIcon size={15} data-id="element-266" data-mp="2w4mmi1exreo2" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}